import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface ErrorStateProps {
  emoji?: string;
  title: string;
  description?: string;
  action?: ReactNode;
  fullScreen?: boolean;
}

export const ErrorState = ({
  emoji = "🏃💨",
  title,
  description,
  action,
  fullScreen = false,
}: ErrorStateProps) => (
  <div
    className={cn(
      "flex w-full items-center justify-center",
      fullScreen
        ? "h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800"
        : "py-16",
    )}
  >
    <div className="max-w-md px-8 text-center">
      <div className="mb-6 text-7xl">{emoji}</div>
      <h1 className="mb-2 text-2xl font-semibold tracking-tight">{title}</h1>
      {description && (
        <p className="mb-6 text-muted-foreground">{description}</p>
      )}
      {action}
    </div>
  </div>
);
